module.exports = __webpack_public_path__ + "public/img/warning.15bf9ea6.gif";